// extracted by mini-css-extract-plugin
module.exports = {"acko":"kula_acko__aFh4L"};